import React, {Component} from 'react';
import './style.css';
import {connect} from 'react-redux';
import {getEnv} from "../../env";
import Slider from "react-slick";

const settings = {
	arrows: false,
	infinite: true,
	autoplay: true,
	speed: 500,
	slidesToShow: 5,
	slidesToScroll: 1,
	variableWidth: true,
	adaptiveHeight: false
};

class BrandLogos extends Component {
	render() {
		const logos = this.props.images.filter(image => image.type === "brands");
		return (
			<div className="con-brandlogos">
				<Slider {...settings}>
					{logos.map((logo, index) =>
						<div className="logo" key={index}>
							<img src={getEnv('S3_ASSETS_BUCKET') + '/' + logo.path} alt="logo"/>
						</div>
					)}
				</Slider>
			</div>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		images: store.adminImages.images,
	};
};

export default connect(mapStateToProps, null)(BrandLogos);


// WEBPACK FOOTER //
// ./src/04-containers/BrandLogos/index.js